export default {
  dashboard: {
    company: {
      total: "Totaal aantal bedrijven",
    },
    person: {
      total: "Totaal aantal contacten",
    },
    invoice: {
      action: "Facturen die actie vereisen",
      yearlyChart: "Rapport betaalde facturen",
    },
  },

  company: {
    search: "Bedrijven zoeken",
    list: "Bedrijven overzicht",

    info: "Bedrijfsnaam",

    address: "Adressen",
    emailAddress: "E-mailadressen",
    bankAccount: "Bankrekeningen",
    phoneNumber: "Telefoonnummers",

    contactPerson: "Contactpersonen",
    relationCompany: "Gelieerde bedrijven",
    businessNumbers: "Zakelijke nummers",

    dossier: {
      list: "Dossier overzicht",
      search: "Dossier zoeken",
    },
  },

  person: {
    search: "Contacten zoeken",
    list: "Contacten overzicht",

    info: "Naam contactpersoon",

    address: "Adressen",
    emailAddress: "E-mailadressen",
    bankAccount: "Bankrekeningen",
    phoneNumber: "Telefoonnummers",

    contactPerson: "Gelieerde bedrijven",
    personNumbers: "Contactpersoon nummers",

    dossier: {
      list: "Dossier overzicht",
      search: "Dossier zoeken",
    },
  },

  invoice: {
    list: "Facturen lijst",
    search: "Facturen zoeken",
    invoice: "Factuur gegevens",
    target: "Factuur aan",
    item: "Factuur regels"
  },
}
